export default `
  subscription OnCreateTeamMember($projectId: String) {
    onCreateTeamMember (projectId: $projectId) {
      projectId
      createTeamMemberFunction {
        id
        userId
        email
        projectId
        lastLogin
        createdAt
        user {
          id
          firstname
          lastname
          email
        }
        project {
          id
          name
          organisationId
          organisation {
            id
            name
            userId
            user {
              id
              firstname
              lastname
            }
          }
        }
      }
    }
  }
`
